import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-right-small",
  "use": "icon-arrow-right-small-usage",
  "viewBox": "0 0 6 9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 6 9\" id=\"icon-arrow-right-small\"><path fill=\"#565656\" d=\"M5.472 4.317L1.644.491a.429.429 0 1 0-.609.607L4.56 4.62 1.036 8.144a.43.43 0 1 0 .608.608l3.828-3.827a.434.434 0 0 0 0-.608z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol